import { Badge, BadgeProps } from 'antd';
import { FC } from 'react';

import { useUser } from '../UserProvider';

import { useNotificationsQuery } from './Notifications.generated';

type NotificationBadgeProps = Omit<BadgeProps, 'count'>;

const NotificationBadge: FC<NotificationBadgeProps> = (props) => {
  const { id: userId } = useUser();

  const { data } = useNotificationsQuery({
    pollInterval: 60000,
    variables: {
      filter: {
        read: false,
        userId,
      },
    },
  });

  return <Badge count={data?.notifications.count} {...props} />;
};

export default NotificationBadge;
